import SystemKeyboardKeyItem from "../items/SystemKeyboardKeyItem";

export function PositiveIntegerExpressionKeyboard({onKeyButtonPressed, isKeyButtonDisabled}) {
    // Used through games and exercisers that expect positive decimal as
    // user answer

    // PROPERTIES
    const positiveIntegerExpressionKeys = [
        '1', '2', '3', '4',
        '5', '6', '7', '8',
        '9', '0','(', ')',
        'n', '+', '-', 'x'];
    const nonNumericItems = ['(', ')', 'n', '+', '-', 'x']

    // BUILD
    return (
        <div className="w-full grid grid-cols-4 gap-[12px]">
            {positiveIntegerExpressionKeys.map((item, index) => (
                <SystemKeyboardKeyItem key={index}
                                       item={item}
                                       onKeyButtonPressed={onKeyButtonPressed}
                                       isKeyButtonDisabled={isKeyButtonDisabled}
                                       isKeyNonNumeric={isKeyNonNumeric(item)} />
            ))}
        </div>
    );

    // METHODS
    // ---- UI : Check if item key is non-numeric
    function isKeyNonNumeric(item) {
        return nonNumericItems.includes(item)
    }
}